export default "__VITE_ASSET__CePBWi$G__"